export default "__VITE_ASSET__4de2272a__"